import { Routes } from '@angular/router';
import {
  AuthGuard,
  guestGuard,
  getLoggedInRedirectPath,
} from './core/auth/guards/auth-guard.service';

export const routes: Routes = [
  { path: '', redirectTo: () => getLoggedInRedirectPath(), pathMatch: 'full' },
  { path: 'dashboard', redirectTo: '/teacher/dashboard', pathMatch: 'full' },
  { path: 'dashbord', redirectTo: '/teacher/dashboard', pathMatch: 'full' },

  // Public Routes
  {
    path: 'home',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('../homepage/homePageComponent/home.component').then(
        m => m.SamWelcomePageComponent
      ),
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import(
        '../homepage/sharedComponents/privacy-policy/privacy-policy.component'
      ).then(m => m.PrivacyPolicyComponent),
  },
  {
    path: 'terms-of-service',
    loadComponent: () =>
      import(
        '../homepage/sharedComponents/terms-of-service/terms-of-service.component'
      ).then(m => m.TermsOfServiceComponent),
  },
  {
    path: 'self-onboard',
    loadComponent: () =>
      import('./features/authentication/self-onboard/self-onboard-wizard/self-onboard-wizard.component').then(
        m => m.SelfOnboardWizardComponent
      ),
  },
  // Parent consent link emailed from the backend: /consent/<country>?userId=&schoolId=
  {
    path: 'consent/:country',
    loadComponent: () =>
      import('./features/consent/parent-consent/parent-consent.component').then(
        m => m.ParentConsentComponent
      ),
  },

  // Auth Routes
  {
    path: '',
    loadChildren: () =>
      import('./features/authentication/auth.routes').then(m => m.AUTH_ROUTES),
  },

  // Shell Routes (Admin, Super Admin, School Dashboards)
  {
    path: '',
    loadChildren: () =>
      import('./shell/shell.routes').then(m => m.SHELL_ROUTES),
  },

  // Navbar Component (Internal/Shared)
  {
    path: 'navbar',
    loadComponent: () =>
      import('./shell/navbar/navbar.component').then(
        m => m.NavbarComponent
      ),
  },
  {
    path: 'spinner',
    loadComponent: () =>
      import('./shared/ui/spinner/spinner.component').then(
        m => m.SpinnerComponent
      ),
  },

  // Teacher Application Routes
  {
    path: 'teacher',
    loadChildren: () => import('./teacher.routes').then(m => m.TEACHER_ROUTES),
  },

  {
    path: 'offline',
    loadComponent: () =>
      import('./shared/pages/network/network-offline.component').then(
        m => m.NetworkOfflineComponent
      ),
  },
  {
    path: 'something-went-wrong',
    loadComponent: () =>
      import('./shared/pages/error/something-went-wrong.component').then(
        m => m.SomethingWentWrongComponent
      ),
  },

  // Fallback
  {
    path: '**',
    loadComponent: () =>
      import('./shared/pages/page-not-found/page-not-found.component').then(
        m => m.PageNotFoundComponent
      ),
  },
];
